import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class MemberService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/member', {
        profile: '/profile',
        changePassword: '/profile/password/change',
        deleteProfile: '/profile/remove',
        beneficiaries: '/beneficiaries',
        reportDonations: '/report/donations',
        reportInwin: '/report/inwin',
      }),

      ...createPrefix('/inwin', {
        targetBeneficiaries: '/beneficiaries/inwin',
        binaryBet: '/match/bet/binary',
        bets: '/bets',
      }),
    }
  }

  static create() {
    return new MemberService()
  }

  async queryBeneficiaries(params) {
    const servicePath = this.endpoints.beneficiaries()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async queryTargetBeneficiaries(params) {
    const servicePath = this.endpoints.targetBeneficiaries()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async binaryInWin({
    triggers,
    amount,
    sponsors,
    beneficiary,
    sponsorAmount,
  }) {
    const servicePath = this.endpoints.binaryBet()

    const { data } = await axios.post(servicePath, {
      amount: amount,
      beneficiaryId: beneficiary.id,
      contributors: sponsors?.id
        ? [
          {
            amount: +sponsorAmount,
            id: sponsors.id,
          },
        ]
        : [],
      triggerId: triggers.id,
    })
    return data
  }

  async queryInWins(params) {
    const servicePath = this.endpoints.bets()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getCurrentProfile() {
    const servicePath = this.endpoints.profile()
    const { data } = await axios.get(servicePath)
    return data
  }

  async updateProfile(profileChanges) {
    const servicePath = this.endpoints.profile()
    const { data } = await axios.put(servicePath, profileChanges, {
      skipErrorToaster: true
    })
    return data
  }

  async changePassword(oldPassword, newPassword) {
    const servicePath = this.endpoints.changePassword()
    const { data } = await axios.post(servicePath, {
      newPassword,
      password: oldPassword,
    }, {
      skipErrorToaster: true
    })
    return data
  }

  async downloadDonations(year) {
    const servicePath = this.endpoints.reportDonations()
    const response = await axios.get(`${servicePath}/${year}`, {
      responseType: 'blob',
    })
    const fileBlob = new Blob([response.data], { type: 'application/pdf' })
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(fileBlob)
    link.href = url
    link.setAttribute('download', `Donations_${year}.pdf`)
    document.body.appendChild(link)
    // Programmatically click the link to trigger the download
    link.click()
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  async downloadReceipt(inwinId) {
    const servicePath = this.endpoints.reportInwin()
    const response = await axios.get(`${servicePath}/${inwinId}`, {
      responseType: 'blob',
      headers: {
        accept: 'application/pdf'
      }
    })
    const fileBlob = new Blob([response.data], { type: 'application/pdf' })
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(fileBlob)
    link.href = url
    link.setAttribute('download', `InWin_Receipt_${inwinId}.pdf`)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  async requestReceiptByEmail(inwinId) {
    const servicePath = this.endpoints.reportInwin()
    const { data } = await axios.post(`${servicePath}/${inwinId}`, '', {
      headers: {
        accept: 'application/pdf'
      }
    })
    return data
  }

  async getDonationAmounts() {
    const servicePath = this.endpoints.reportDonations()
    const { data } = await axios.get(`${servicePath}/amount`)
    return data
  }

  async deleteProfile() {
    const servicePath = this.endpoints.deleteProfile()
    const { data } = await axios.delete(servicePath, {
      skipErrorToaster: true
    })
    return data
  }
}
